import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";

import { store } from "redux/store";
import reportWebVitals from "reportWebVitals";

import RouterApp from "App";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import ReactGA from "react-ga4";

const env = (process.env.REACT_APP_ENVIRONMENT || "").trim();
const ga4Id = (process.env.REACT_APP_GA4_ID || "").trim();

if (process.env.NODE_ENV !== "production") {
  console.log("GA Debug: Environment check", {
    REACT_APP_ENVIRONMENT: `"${process.env.REACT_APP_ENVIRONMENT}"`,
    REACT_APP_GA4_ID: `"${process.env.REACT_APP_GA4_ID}"`,
    envTrimmed: `"${env}"`,
    ga4IdTrimmed: `"${ga4Id}"`,
    isNotOnPrem: env !== "ON_PREM",
    hasGA4ID: Boolean(ga4Id),
    shouldInitialize: env !== "ON_PREM" && Boolean(ga4Id),
  });
}

if (env !== "ON_PREM" && ga4Id) {
  if (process.env.NODE_ENV !== "production") {
    console.log("GA Debug: About to initialize ReactGA with ID:", ga4Id);
  }
  ReactGA.initialize(ga4Id);
  if (process.env.NODE_ENV !== "production") {
    console.log("GA Debug: ReactGA initialized successfully");
  }
} else {
  if (process.env.NODE_ENV !== "production") {
    console.log(
      "GA Debug: Skipping ReactGA initialization - ON_PREM environment or no GA4_ID",
    );
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <Provider store={store}>
    <RouterApp />
  </Provider>,
);

reportWebVitals();
